<script setup>
defineOptions({ name: 'GamePagination' });

import { computed } from 'vue';
import { useGamesStore } from '../stores/games/gamesStore';

const props = defineProps({
  currentPage: {
    type: Number,
    required: true
  },
  gamesPerPage: {
    type: Number,
    required: true
  }
});

const emit = defineEmits(['update:currentPage']);
const gamesStore = useGamesStore();

const totalPages = computed(() => 
  Math.ceil(gamesStore.games.length / props.gamesPerPage)
);

const goToNextPage = () => {
  if (props.currentPage < totalPages.value) {
    emit('update:currentPage', props.currentPage + 1);
  }
};

const goToPrevPage = () => {
  if (props.currentPage > 1) {
    emit('update:currentPage', props.currentPage - 1);
  }
};
const goToPage = (pageNumber) => {
  emit('update:currentPage', pageNumber);
};

const pageNumbers = computed(() => {
  return Array.from({ length: totalPages.value }, (_, i) => i + 1);
});
</script>
<template>
    <div class="grid-navigation">
      <button 
        class="nav-button-pagination prev"
        @click="goToPrevPage" 
        :disabled="currentPage === 1"
      >
        <font-awesome-icon icon="chevron-left" size="2x" />
      </button>
      <button 
        class="nav-button-pagination next"
        @click="goToNextPage" 
        :disabled="currentPage === totalPages"
      >
        <font-awesome-icon icon="chevron-right" size="2x" />
      </button>
    </div>
    <!-- Indicadores de página con números -->
    <div class="page-indicators">
      <span class="page-number">1</span>
      <button
        v-for="page in pageNumbers"
        :key="page"
        v-show="page > 1 && page < totalPages"
        class="page-dot"
        :class="{ active: page === currentPage }"
        @click="goToPage(page)"
        :aria-label="'Go to page ' + page"
      />
      <span class="page-number">{{ totalPages }}</span>
    </div>
  </template>
  
<style scoped>
@import '../assets/styles/main.css';
</style>